import { Component } from "@angular/core";
import { Observable, map } from "rxjs";
import { WindowConfig, WindowManagerService } from "../window-manager.service";

@Component({
  selector: "app-window-bar",
  templateUrl: "./window-bar.component.html",
  styleUrls: ["./window-bar.component.scss"],
  standalone: false,
})
export class WindowBarComponent {
  minimizedWindows$: Observable<WindowConfig[]> =
    this.windowService.windows$.pipe(
      map((windows) => windows.filter((w) => w.minimized))
    );

  constructor(private windowService: WindowManagerService) {}

  restore(win: WindowConfig) {
    this.windowService.select(win);
    this.windowService.restore(win);
  }

  close(win: WindowConfig) {
    this.windowService.close(win);
  }
}
